import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/industries/education-and-campus-safety/components/EduCampusSafetyView.tsx");
